import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Calendar,
  CalendarCells,
  CalendarDays,
  CalendarHeader,
  CalendarProvider,
  doughnutOptions,
  getChartData,
} from '../calendar';
import ProcReqFilters from './ProcReqFilters';
import { format, parse } from 'date-fns';
import queryString from 'query-string';
import { Doughnut } from 'react-chartjs-2';
import {
  changeProcRequestDisplay,
  changeProcRequestPopupWindow,
  getProcRequestCurrentMonthAndYear,
  getProcRequests,
  selectProcRequest,
  selectTargetDayForProcRequests,
} from '../../actions/procRequestAction';
import styles from '../../styles/calendar/Calendar.module.scss';
import { generateSafeDateFromMonthYear } from '../../utils/helper';

ChartJS.register(ArcElement, Tooltip, Legend);

const ProcRequestsCalendar = ({
  storageKey,
  selectedDate,
  setSelectedDate,
  statuses,
  setStatuses,
  ...props
}) => {
  const [sortByDateNeeded, setSortByDateNeeded] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(() => {
    return localStorage.getItem(storageKey) !== null
      ? localStorage.getItem(storageKey)
      : format(new Date(), 'MMM yyyy');
  });
  const STATUS_KEYS = Object.keys(statuses);

  const renderCellContent = (procRequestsForTheDay, day) => {
    const currentDate = parse(currentMonth, 'MMM yyyy', new Date());
    currentDate.setDate(day);

    const chartData = {};
    let totalProcRequests = 0;

    STATUS_KEYS.forEach(statusKey => {
      if (statuses[statusKey]) {
        chartData[statusKey] = procRequestsForTheDay.filter(
          req => req.status.toLowerCase() === statusKey
        );
        totalProcRequests += chartData[statusKey].length;
      } else {
        chartData[statusKey] = [];
      }
    });

    const doughnutData = getChartData(chartData, 'Proclamation Requests');

    return (
      <div
        className={styles['request-calendar-day-container']}
        style={{ padding: '3px' }}>
        <div className={styles['num-container']}>
          <p
            className={styles['total-requests-num']}
            style={{ marginBottom: '0' }}>
            {totalProcRequests}
          </p>
          <p style={{ fontSize: '0.8rem', marginBottom: '0' }}>
            {totalProcRequests === 1 ? 'Request' : 'Requests'}
          </p>
        </div>
        <Doughnut
          width={110}
          height={110}
          type='doughnut'
          data={doughnutData}
          options={doughnutOptions}
        />
      </div>
    );
  };

  const handleOnDateClick = day => {
    const idx = format(day, 'd');
    const filteredProcRequests = props.procRequests[idx]?.filter(ele => {
      const status = ele.status?.toLowerCase();
      return statuses[status];
    });

    if (filteredProcRequests.length > 0) {
      const currentDate = parse(currentMonth, 'MMM yyyy', new Date());
      currentDate.setDate(idx);
      props.selectTargetDayForProcRequests(filteredProcRequests);
    }
    if (filteredProcRequests.length === 1) {
      props.selectProcRequest(filteredProcRequests[0]);
      props.changeProcRequestDisplay('detail');
    }
    if (filteredProcRequests.length > 1) {
      props.changeProcRequestDisplay('list');
    }
  };
  useEffect(() => {
    let currentDate;
    if (localStorage.getItem(storageKey) !== null) {
      currentDate = generateSafeDateFromMonthYear(
        localStorage.getItem(storageKey)
      );
    } else {
      currentDate = new Date();
    }

    props.getProcRequestCurrentMonthAndYear(
      currentDate.getMonth() + 1,
      currentDate.getFullYear(),
      sortByDateNeeded
    );
    props.getProcRequests(props.nextAPI, props.params);
    const trackerId = queryString.parse(window.location.search).id;
    if (trackerId) {
      props.openNotificationDetailReport(trackerId);
      props.changeReportTrackingDisplay('detail');
    }
  }, []);

  return (
    <CalendarProvider
      currentMonth={currentMonth}
      setCurrentMonth={setCurrentMonth}
      storageKey={storageKey}>
      <Calendar>
        <CalendarHeader
          sortByDateNeeded={sortByDateNeeded}
          isLoading={props.isLoading}
          getRequestCurrentMonthAndYear={
            props.getProcRequestCurrentMonthAndYear
          }>
          <ProcReqFilters
            getProcRequestCurrentMonthAndYear={
              props.getProcRequestCurrentMonthAndYear
            }
            setSortByDateNeeded={setSortByDateNeeded}
            sortByDateNeeded={sortByDateNeeded}
            statuses={statuses}
            setStatuses={setStatuses}
            changeProcRequestDisplay={props.changeProcRequestDisplay}
            changeProcRequestPopupWindow={props.changeProcRequestPopupWindow}
            userProfile={props.userProfile}
          />
        </CalendarHeader>
        <CalendarDays />
        <CalendarCells
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          isLoading={props.isLoading}
          onDateClick={handleOnDateClick}
          calendarData={props.isLoading ? [] : props.procRequests}
          renderCellContent={renderCellContent}
        />
      </Calendar>
    </CalendarProvider>
  );
};

const mapStateToProps = state => {
  return {
    procRequests: state.procRequestReducer.allProcRequestsForDays,
    userProfile: state.userReducer.userProfile,
    nextAPI: state.procRequestReducer.nextAPI,
    isLoading: state.procRequestReducer.isCalendarLoading,
    params: {
      sort_direction: state.procRequestReducer.procRequestSortDirection,
      sort_by: state.procRequestReducer.procRequestSortedBy,
      filter: state.procRequestReducer.procRequestFilter,
    },
  };
};
const mapDispatchToProps = {
  selectProcRequest,
  selectTargetDayForProcRequests,
  getProcRequestCurrentMonthAndYear,
  changeProcRequestDisplay,
  changeProcRequestPopupWindow,
  getProcRequests,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProcRequestsCalendar);
